import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["canvas"];

  static values = {
    chartData: {type: Array, default: []}
  }

  connect() {
    Chart.register(ChartDataLabels);
    var data = [
      {
        backgroundColor: ["#E8443F", "#EF7976", "#F9CAC8"],
        data: [
                this.chartDataValue[0],
                this.chartDataValue[1],
                this.chartDataValue[2]
              ],
      },
    ];

    var options = { 
      elements: {
          arc: {
              borderWidth: 0
          }
      },
      tooltips: {
        enabled: false,
      },
      plugins: {
        datalabels: {
          formatter: (value, ctx) => {
            let datasets = ctx.chart.data.datasets;
            if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
              let sum = datasets[0].data.reduce((a, b) => a + b, 0);
              let percentage = Math.round((value / sum) * 100) + "%";
              if (percentage != "0%"){
                 return percentage;
              }else{
                return "";
              }
            }else{
              return "";
            }
          },
          color: "#fff",
        },
      },
    };

    var ctx = this.canvasTarget.getContext("2d");

    var myChart = new Chart(ctx, {
      type: "pie",
      data: {
        datasets: data,
      },
      options: options,
    });
  }
}
